import React from 'react';
import { PRIVACY_POLICY } from './lib/constants';
import { PrivacyPolicyContentBlock, PrivacyPolicySectionBlock } from './lib/types';
import { renderParagraph } from './lib/renderParagraph';
import { useTranslation } from 'react-i18next';

const PrivacyPolice: React.FC = () => {
  const { t } = useTranslation();
  return (
    <main>
      <div className="container" style={{ maxWidth: '1130px', paddingTop: '2rem' }}>
        {PRIVACY_POLICY.map((section: PrivacyPolicySectionBlock) => (
          <section key={section.id}>
            <h2 style={{ fontSize: '22px' }}>{t(section.title)}</h2>
            {section.content.map((block: PrivacyPolicyContentBlock) => (
              <div key={block.id}>{block.paragraphs.map(p => renderParagraph(p, t))}</div>
            ))}
          </section>
        ))}
      </div>
    </main>
  );
};

export default PrivacyPolice;
